import { submitPrequalApplication } from 'fmc-sdk';
import { useSelector } from 'react-redux';
import usePrequalificationApplication from 'hooks/requests/prequalificationApplication';
import { selectCreditApplication } from 'state/creditApplication';
import useNavigationHelpers from 'hooks/useNavigationHelpers';
import useFmcHost from 'hooks/useFmcHost';
import { useCallback } from 'react';
import useAnalytics, { Event } from 'hooks/useAnalytics';

import { FormValues } from './UnifiedPrequalApplicationReview';

const useApplyUnifiedPrequalApplication = () => {
  const application = useSelector(selectCreditApplication);
  const [applyPrequalApplication] = usePrequalificationApplication();

  const { push } = useNavigationHelpers();
  const fmcDispatch = useFmcHost();
  const { sendEvents } = useAnalytics();

  const applyForCredit = useCallback(
    async (params: FormValues) => {
      fmcDispatch(submitPrequalApplication());
      const payload = {
        ...application,
        ...params,
      };
      if (!params.reCaptchaToken) return;
      const { hasExistingAccount, isApproved } = await applyPrequalApplication(
        payload,
        params.reCaptchaToken,
      );

      if (!isApproved) {
        push('/credit-pending');
      } else {
        if (hasExistingAccount) {
          push('/existing-account');
        } else {
          sendEvents([Event.ApplicationApproved, Event.ApplicationCompleted]);
          push('/approval');
        }
      }
    },
    [fmcDispatch, application, applyPrequalApplication, push, sendEvents],
  );
  return applyForCredit;
};

export default useApplyUnifiedPrequalApplication;
